import { render, staticRenderFns } from "./ListSeguroicancelarPage.vue?vue&type=template&id=ab3eb2b4&"
import script from "./ListSeguroicancelarPage.vue?vue&type=script&lang=js&"
export * from "./ListSeguroicancelarPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports